import { render, staticRenderFns } from "./editAllocationStorehouseApplyList.vue?vue&type=template&id=a8a93b38&scoped=true"
import script from "./editAllocationStorehouseApplyList.vue?vue&type=script&lang=js"
export * from "./editAllocationStorehouseApplyList.vue?vue&type=script&lang=js"
import style0 from "./editAllocationStorehouseApplyList.vue?vue&type=style&index=0&id=a8a93b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a93b38",
  null
  
)

export default component.exports